<template>
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 0C3.634 0 0.5 3.134 0.5 7C0.5 10.866 3.634 14 7.5 14C11.366 14 14.5 10.866 14.5 7C14.5 3.134 11.366 0 7.5 0ZM10.5035 3.27868L11.9579 4.73303L7.41541 9.27638L5.9696 10.7213L4.51526 9.26697L3.04211 7.79296L4.48706 6.34801L5.96021 7.82201L10.5035 3.27868Z" fill="#2CC13B"/>
  </svg>
</template>
